module.exports = __webpack_public_path__ + "img/Insomnia.d6eaf89c.svg";